import { useCallback } from 'react';

import { useTrackAgentPanelOpened } from '@air/analytics';

import { useIsWorkspaceAgentPanelAvailable } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useIsWorkspaceAgentPanelAvailable';
import { useWorkspaceAgentPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const useOpenWorkspaceAgentCommand = () => {
  const { isWorkspaceAgentPanelAvailable } = useIsWorkspaceAgentPanelAvailable();
  const { currentWorkspace } = useCurrentWorkspace();
  const showChat = useWorkspaceAgentPanelStore((state) => state.showChat);
  const startNewThreadWithHeroSeed = useWorkspaceAgentPanelStore((state) => state.startNewThreadWithHeroSeed);
  const { trackAgentPanelOpened } = useTrackAgentPanelOpened();

  const openWorkspaceAgent = useCallback(
    (prompt: string | undefined) => {
      const panel = useWorkspaceAgentPanelStore.getState();
      const wasMinimized = panel.dock === 'minimized';

      if (prompt) {
        startNewThreadWithHeroSeed('announcement', {
          prompt,
          sendImmediately: true,
          source: 'announcement',
          workspaceId: currentWorkspace?.id,
        });
      } else {
        showChat();
        panel.setPendingThreadCreatedLocation('announcement');
      }

      if (wasMinimized) {
        trackAgentPanelOpened({ location: 'announcement' });
      }
    },
    [currentWorkspace?.id, showChat, startNewThreadWithHeroSeed, trackAgentPanelOpened],
  );

  return {
    canOpenWorkspaceAgent: isWorkspaceAgentPanelAvailable,
    openWorkspaceAgent,
  };
};
